import { forwardRef, HTMLAttributes, memo } from "react";
import classNames from "classnames";
import { CheckIcon, CheckIconProps } from "../CheckIcon";

import styles from "./styles.module.scss";

export type CheckItemTextSize = "sm" | "md" | "lg";

export type CheckItemTextProps = HTMLAttributes<HTMLDivElement> & {
  size?: CheckItemTextSize
  checkIconProps?: CheckIconProps
};

export const CheckItemText = memo(forwardRef<HTMLDivElement, CheckItemTextProps>((
  {
    size = "sm",
    children,
    className,
    checkIconProps,
    ...props
  }, ref) => {
  return (
    <div
      {...props}
      ref={ref}
      className={classNames(
        className,
        styles.root,
        styles[size],
      )}
    >
      <CheckIcon {...checkIconProps} />
      {children}
    </div>
  );
}));